const footerLinks = {
  热门分类: ['国产剧', '美剧', '韩剧', '日剧', '动漫', '综艺', '纪录片', '电影'],
  帮助中心: ['常见问题', '播放问题', '账号相关', '内容反馈', '侵权申诉'],
  关于我们: ['平台介绍', '更新日志', '加入我们', '联系方式'],
};

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <span className="font-heading text-xl font-bold text-primary-500">人人影视</span>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              人人影视高清免费在线观看平台，汇聚海量免费影视资源，覆盖热门电视剧全集与电影大全。高清画质免付费，不缓冲秒播极速播放，即点即看。致力于为广大影迷提供最优质的高清免费在线观看体验。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-3">
                {title}
              </h4>
              <ul className="flex flex-col gap-2">
                {links.map((link) => (
                  <li key={link}>
                    <a
                      href="#"
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                      onClick={(e) => e.preventDefault()}
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-4 flex-wrap justify-center">
              <span className="text-xs text-foreground-500">合作伙伴</span>
              <span className="text-xs text-foreground-400">——</span>
            </div>
            <p className="text-xs text-foreground-500 text-center">
              &copy; {new Date().getFullYear()} 人人影视 版权所有
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}